import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
// Imported for its module-load side effect: it snapshots Stripe's `?session_id=…` before
// the hash-location router rewrites the URL and drops the query. See payment-config.ts.
import './app/payments/payment-config';

// The router uses hash location, but /signup is a public entry point linked as a plain path.
// Move it (and its query string) into the fragment before bootstrap so the router resolves it.
if (window.location.pathname === '/signup' && !window.location.hash) {
  window.history.replaceState(null, '', `/#/signup${window.location.search}`);
}

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
